import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminImportMedications;

export const adminImportMedicationsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminImportMedicationsErrorsSelector = (state: RootState) => getState(state).errors;

export const adminImportSynonymsListLoadingSelector = (state: RootState) =>
  getState(state).isLoadingSynonymsList;
export const adminImportSynonymsListErrorsSelector = (state: RootState) =>
  getState(state).errorsSynonymsList;
